const initialState = {
	isFetching: false
}

export function autocomplete(state = initialState, action) {
	switch (action.type) {
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/autocomplete.js